import {ValueObject} from '@s-ui/domain'

export class ValidatePhoneVerificationCodeUserRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.code
   * @param {String} data.phone
   **/

  static validate({code, phone, validatePhoneVerificationCodeError}) {
    const checkParamExists = param => param !== undefined && param !== null

    if (!checkParamExists(code)) {
      throw validatePhoneVerificationCodeError({code: 'Code is mandatory.'})
    }
    if (!checkParamExists(phone)) {
      throw validatePhoneVerificationCodeError({code: 'Phone is mandatory.'})
    }
  }
}
